module.exports = __webpack_public_path__ + "static/img/aboutus.652befc7.png";